import { render } from "./ConfigurtionPage.vue?vue&type=template&id=0afe1943"
import script from "./ConfigurtionPage.vue?vue&type=script&lang=js"
export * from "./ConfigurtionPage.vue?vue&type=script&lang=js"

import "./ConfigurtionPage.vue?vue&type=style&index=0&id=0afe1943&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__